import { Grid, styled, type Theme, Typography } from "@mui/material";

export const RuleLibraryFilterContainer = styled(Grid)(({ theme }: { theme: Theme }) => ({
	marginTop: "10px",
	marginLeft: "20px",
	marginRight: "25px",
	[theme.breakpoints.up(1700)]: {
		marginLeft: "45px",
		marginRight: "77px"
	}
}));

export const RuleLibraryPaginationContainer = styled("div")(({ theme }: { theme: Theme }) => ({
	display: "flex",
	marginLeft: "375px",
	[theme.breakpoints.up(1700)]: {
		marginLeft: "475px"
	},
	padding: "15px"
}));

export const RuleLibraryTotalRowsContainer = styled("div")(() => ({
	display: "flex",
	padding: "15px"
}));

export const RuleLibraryPaginationTotalRows = styled(Typography)(() => ({
	fontSize: "1rem",
	padding: "5px"
}));

// `RuleLibraryLongTextCell` switches its CSS off boolean-flag string props
// passed as `"true"` / `"false"` (avoids React's prop-as-attribute warning
// when the underlying div leaks them to the DOM).
type LongTextCellProps = {
	overflowing?: "true" | "false";
	before?: "true" | "false";
	trashed?: "true" | "false";
};

export const RuleLibraryLongTextCell = styled("div")<LongTextCellProps>(
	({ theme, overflowing = "false", before = "false", trashed = "false" }) => {
		const baseStyles = {
			fontSize: theme.typography.body2.fontSize,
			textWrap: "wrap" as const,
			height: "50px",
			alignContent: "center",
			lineHeight: "16px",
			color: trashed === "true" ? theme.palette.text.disabled : theme.palette.text.primary
		};

		const beforeStyles = before === "true"
			? {
				"&::before": {
					content: "'Draft '",
					letterSpacing: "0.17px",
					color: theme.palette.error.main,
					fontWeight: 700,
					fontSize: theme.typography.body2.fontSize
				}
			}
			: {};

		const overflowStyles = overflowing === "true"
			? {
				"&::after": {
					content: "'...'",
					letterSpacing: "0.5px"
				}
			}
			: {};

		return { ...baseStyles, ...overflowStyles, ...beforeStyles };
	}
);
